import actions from "@/store/modules/bookings/interviews/actions";
import {
  mutations,
  state
} from "@/store/modules/bookings/interviews/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
